import * as React from 'react';
import EarningTable from './EarningTable';
import Dashboard from '../Dashboard/Dashboard';


export default function Earning() {

  return (
   <Dashboard>
        
       <EarningTable/>
       </Dashboard>



  );
}
